export default "__VITE_ASSET__CfyKNQW9__"